import { useContext, useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { useGeo } from '../contexts/GeoContext.js';
import { JourneyContext } from '../contexts/JourneyContext.js';
import CloudBackground from '../elements/CloudBackground.jsx';
import LargeButton from '../elements/LargeButton.jsx';
// import Map from '../elements/Map';
import SmallButton from '../elements/SmallButton';
import styles from '../Styles.jsx';

export default function ScreenPermissions(props) {
  const journeyContext = useContext(JourneyContext);
  const geoContext = useGeo();
  const [permissionRequested, setPermissionRequested] = useState(false);

  // Initialize location tracking when screen loads if permissions are already granted
  useEffect(() => {
    if (geoContext.initializeLocationTracking) {
      geoContext.initializeLocationTracking();
    }
  }, [geoContext]);

  // If permissions are reported granted but we don't yet have coordinates, try to get one quick fix.
  useEffect(() => {
    if (geoContext.hasGPSAccess && (!geoContext.coordinates || geoContext.coordinates.latitude == null || geoContext.coordinates.longitude == null)) {
      // Try to get a single current position to populate the UI quickly.
      geoContext.getCurrentPosition().catch(() => {});
    }
  }, [geoContext, geoContext.hasGPSAccess, geoContext.coordinates?.latitude, geoContext.coordinates?.longitude]);

  const _finishedPermissions = () => {
    // If user is returning to permissions via GPS prompt, use continue function
    if (journeyContext.isReturningToPermissions) {
      journeyContext.continueFromPermissions();
    } else {
      // Normal first-time permissions completion
      journeyContext.finishedPermissions();
    }
  };

  const _requestPermissions = async () => {
    setPermissionRequested(true);
    const granted = await geoContext.requestPermissions();
    if (granted) {
      // Permissions granted, location tracking should start automatically
      console.log('Location permissions granted');
    } else {
      console.log('Location permissions denied');
    }
  };

  const _mapElement = () => {
  if (geoContext.hasGPSAccess && geoContext.coordinates && geoContext.coordinates.latitude != null && geoContext.coordinates.longitude != null) {
      return (
        <Text style={{ textAlign: 'center', fontSize: 18, color: 'green' }}>
          {geoContext.coordinates.latitude.toFixed(5)}, {geoContext.coordinates.longitude.toFixed(5)}
        </Text>
      );
    } else {
      return (
        <Text style={{ textAlign: 'center', fontSize: 16, color: 'gray' }}>
          Location access not granted yet.
        </Text>
      );
    }
  };
  return (
    <CloudBackground>
      <View style={{ margin: 20, marginTop: 80, marginBottom: 50 }}>
        <View style={{ backgroundColor: '#f7f7f7', borderRadius: 16, padding: 20 }}>

          {/* Message / intro */}
          <View style={{ marginBottom: 14 }}>
            <Text style={{ fontSize: 18, lineHeight: 26, textAlign: 'center' }}>
              {journeyContext.isReturningToPermissions ? (
                `Please confirm your location permissions are enabled.\n\nIf everything is working, you'll see your position below and can continue your journey.`
              ) : (
                `Before we start, please allow the app to access your device's location.\n\nThis will let the app guide you to the hidden performances. If everything is working, you'll see your latitude and longitude below. If you don't, you may need to check your phone's settings.\n\nYou can decline to grant location access, although it will be more difficult to do the scavenger hunt without it.`
              )}
            </Text>
          </View>

          {/* Error or status text */}
          {geoContext.locationError && (
            <Text style={{ ...styles.captionText, fontSize: 18, color: 'red', textAlign: 'center', marginBottom: 12 }}>
              {geoContext.locationError}
            </Text>
          )}

          {geoContext.hasGPSAccess && geoContext.coordinates && geoContext.coordinates.latitude != null && geoContext.coordinates.longitude != null && (
            <Text style={{ ...styles.captionText, fontSize: 18, color: 'green', textAlign: 'center', marginBottom: 12 }}>
              Location access granted and working
            </Text>
          )}

          {/* Coordinates box */}
          <View style={{ marginVertical: 8 }}>
            <View style={styles.heroGPS}>
              {_mapElement()}
            </View>
          </View>

          {/* Buttons area */}
          <View style={{ marginTop: 18, alignItems: 'center' }}>
            {!geoContext.hasGPSAccess && !permissionRequested && (
              <LargeButton title="Allow Location Access" onPress={ _requestPermissions } />
            )}

            {geoContext.hasGPSAccess && (
              <SmallButton 
                title={journeyContext.isReturningToPermissions ? "Continue" : "Start"} 
                onPress={ _finishedPermissions } 
              />
            )}

            {permissionRequested && !geoContext.hasGPSAccess && (
              <Text style={{ ...styles.captionText, fontSize: 16, textAlign: 'center', marginTop: 12 }}>
                Please check your device settings if location access was denied.
              </Text>
            )}

            <View style={{ marginTop: 14 }}>
              <SmallButton 
                buttonStyle={styles.smallGreyButton}
                textStyle={styles.smallGreyButtonText}
                title="Continue Without Location Access" 
                onPress={ _finishedPermissions }
              />
            </View>
          </View>
        </View>
      </View>
    </CloudBackground>
  );
}